import styled from 'styled-components';
import { token } from '@bynder/design-system';

export const DesignsListRoot = styled.div`
    max-height: 268px;
    overflow-y: auto;
    overflow-x: hidden;

    /* Hide scrollbar for Chrome, Safari and Opera */
    &::-webkit-scrollbar {
        display: none;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
`;

export const Spacing = styled.div`
    height: ${token.spacing5};
`;

export const IconWrapperElement = styled.div<{ isDisabled?: boolean }>`
    color: ${({ isDisabled }) => (isDisabled ? token.colorTextDisabled : token.colorTextMuted)};
`;

export const DisabledText = styled.span`
    color: ${token.colorTextDisabled};
`;
